module.exports = __webpack_public_path__ + "img/68.7303bbce.jpg";